import { setContext } from '@apollo/client/link/context'

import {
  cleanAuthenticationCookie,
  getCookie,
  getUserIdFromAuthToken,
  setAuthenticationCookie,
} from '@/providers/authentication/authentication.helpers'
import { refreshAuthToken } from '@/util/refresh-auth-token'

/**
 * @private only to be used in apolloClient.ts
 */
export const refreshAuthLink = setContext(async () => {
  const userId = getUserIdFromAuthToken()
  const token = getCookie('token')
  const tokenExpiresAt = getCookie('tokenExpiresAt')
  const refreshToken = getCookie('refreshToken')

  if (!token || !tokenExpiresAt || !userId || !refreshToken) {
    return
  }

  if (new Date(tokenExpiresAt) > new Date()) {
    return
  }

  const data = await refreshAuthToken({
    userId,
    refreshToken,
    tokenExpiresAt: new Date(tokenExpiresAt),
  })

  if (data && data.token) {
    setAuthenticationCookie(data)
  } else {
    cleanAuthenticationCookie()
  }
})
